import { CanDeactivateFn } from '@angular/router';
import type { FormDetail } from './form-detail';

/** Quitter le détail d'un formulaire avec des textes non enregistrés demande confirmation. */
export const quitterFormulaireGuard: CanDeactivateFn<FormDetail> = (composant) => composant.peutQuitter();
